<template>
  <div class="center" v-if="error">
    <h2>{{ error }}</h2>
  </div>
</template>

<script>
  import { makeRequest } from 'itrnews-vuejs-api';

  export default {
    name: 'OldVideoPage',
    mounted() {
      makeRequest(`vimeo/old-id/${this.$route.params.id}`).then((response) => {
        const video = response.data;
        if (video.id !== null) {
          this.$router.push({ name: 'VideoPage', params: { id: video.id, slug: this.$route.params.slug } });
        } else {
          this.error = 'Vidéo non trouvée';
        }
      }).catch(() => {
        this.error = 'Vidéo non trouvée';
      });
    },
    data() {
      return {
        error: null,
      };
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/OldVideoPage.vue